<template>
  <div class="category_list">
    <!--检索-->
    <div class="header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/template' }">模板页面</el-breadcrumb-item>
        <el-breadcrumb-item>分类列表</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button  type="primary" @click="toAdd()">新增分类</el-button>
      <!-- <el-col>
        <div class="form-box">
          <div class="input-item">
            <el-input clearable size="medium" placeholder="请根据表单名称搜索" v-model="requestData.name_like">
              <el-button @click="request" slot="append" icon="el-icon-search"></el-button>
            </el-input>
          </div>
        </div>
      </el-col> -->
    </div>

    <!--表格数据-->
    <el-table :data="tableData" align="center" stripe style="width: 100%; margin-top: 20px;">
      <el-table-column prop="category_name" label="分类名称"></el-table-column>
      <el-table-column label="操作" align="right">
        <template slot-scope="scope">
          <el-button type="text" size="medium" @click="edit(scope.row)">编辑</el-button>
          <el-button type="text" size="medium" @click="toDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="actionType === 'add' ? '新增分类' : '编辑分类'"
      :visible.sync="dialogClassVisible"
      width="40%" >

      <el-form ref="form" label-width="140px">
        <el-form-item label="一级分类" prop="template_name">
          <el-input clearable v-model="category_name" :maxlength="20" placeholder="请输入模板名称"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogClassVisible = false; category_name = ''">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>

    </el-dialog>

  </div>
</template>


<script>
export default {
  name: 'FormList',
  data() {
    return {
      actionType: 'add',
      tableData: [],
      category_name: '',
      tempId: '',
      dialogClassVisible: false
    };
  },

  created() {
    this.request();
  },

  methods: {
    request() {
      lib.tmsapi.get({
        api: 'api/test/template_category/list',
        data: this.requestData,
        success: data => {
          this.tableData = data.data || [];
        },
        error: data => {
          if (data && data.msg) {
            this.$message.error(data.msg);
          }
        },
        complete: () => {
        },
      });
    },
    getId(id) {
      return 'form-num-' + id;
    },
    toDelete(id, e) {
      this.$confirm('此操作将删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.remove(id);
        })
    },


    edit(item) {
      this.tempId = item.id
      this.dialogClassVisible = true
      this.category_name = item.category_name
      this.actionType = 'edit'
    },

    toAdd() {
      this.actionType = 'add'
      this.dialogClassVisible = true
    },

    submit () {
      let api, id
      if (this.actionType === 'add') {
        id = ''
        api = 'api/test/template_category/add'
      } else {
        id = this.tempId
        api = 'api/test/template_category/update'
      }
      console.log('apiapiapi', api)
      lib.tmsapi.post({
        api: api,
        data: {
          id,
          category_name: this.category_name
        },
        success: (res) => {
          // 提示成功
          this.dialogClassVisible = false
          this.category_name = ''
          this.$message.success('提交成功！')
          this.request()
        },
        error:(e)=>{
          this.$message.error(e.msg)
        }
      })
    },

    remove(id, cb) {
      var that = this;
      lib.tmsapi.post({
        api: 'api/test/template_category/del',
        data: {
          id: id,
        },
        success: function (data) {
          that.$message.success('删除成功!');
          that.request();
        },
        error: function (data) {
          if (data && data.msg) {
            that.$message.error(data.msg);
          }
        },
        complete: function () {
        },
      });
    },

    handleCurrentChange(val) {
      this.requestData.page = val-1 || 0;
      this.request();
    },
  },
};
</script>

<style lang="scss" scoped>
  .category_list {
    padding: 30px 100px;
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 20px;
      background: #fff;
    }
  }
</style>
